import React from "react";
import { useSelector } from "react-redux";

const Loading = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const theme =projectInfo?.projectConfig?.config?.THEME;
  return (
    <div className="loadingContainer">
      <div className="loading">
        <div className="loadingOverlay"></div>
        {/* <span className={`loader ${theme === "LIGHT" ? "light" : ""}`}></span> */}
        <span className={`loader-spinner ${theme === "LIGHT" ? "light" : ""}`}></span>
        {/* <div className="loadingText">
            <h1>Loading</h1>
            <span>•</span>
            <span>•</span>
            <span>•</span>

        </div> */}
      </div>
    </div>
  );
};

export default Loading;
